import React from 'react';
import Text from '@tamagoshi/core/Text';
import { getTranslations } from '@translations';
import styles from './styles/index.module.scss';

export const Title = () => {
  const translations = getTranslations();

  return (
    <Text type="small" weight="semiBold" className={styles.title}>
      {translations('footer.trust.pro.title')}
    </Text>
  );
};

export const SubTitle = () => {
  const translations = getTranslations();

  return (
    <>
      <Text type="tiny" className={styles.text} weight="bold">
        {translations('footer.trust.pro.subtitle')}
      </Text>
      <Text type="tiny" className={styles.subText}>
        {translations('footer.trust.pro.subtext')}
      </Text>
    </>
  );
};
